export default {
  path: '/ratio-ticket',
  meta: {
    title: '购物积分',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-ticket`),
}



// WEBPACK FOOTER //
// ./src/views/RatioTicket/router.js